module.exports = __webpack_public_path__ + "static/media/RhythmPlanet.c0f0781.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vidio/RhythmPlanet.mp4
// module id = YeHB
// module chunks = 0